import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
//store
import {
	setCityData,
	setActivityFacilityData,
	toggleLocationModal,
	setLoading,
} from "../../configureStore";

// components
import FiltersModal from "../filtersModal/filtersModal";
import SearchModal from "./searchModal";
import LocationBtn from "./location-btn";
import ClearFieldsMobileCont from "./clearFieldsMobileCont";
import ClearFieldsBtn from "./clearFieldsBtn";
import ToggleFiltersMobileBtn from "./toggleFiltersMobileBtn";
import ToggleFiltersDesktopBtn from "./toggleFiltersDesktopBtn";
import SearchBtn from "./searchBtn";
import AjaxSelect from "./selects/AjaxSelect";
import LocationModal from "../locationModal";

const Search = (props) => {
	const dispatch = useDispatch();
	const [modalIsOpen, setModalState] = useState(false);
	const [searchModalIsOpen, setsearchModalState] = useState(false);
	const [modalStateLocation, setModalStateLocation] = useState(false);
	const [hasFilters, setHasFilters] = useState(null);
	const searchData = useSelector((state) => state.searchData);
	const localization = useSelector((state) => state.global.localization);
	const global = useSelector((state) => state.global);
	const formRef = useRef(null);

	useEffect(() => {
		if (
			searchData.city.name !== "" ||
			searchData.activityFacility.name !== ""
		) {
			setHasFilters(true);
		} else {
			setHasFilters(false);
		}
	}, [searchData.city, searchData.activityFacility]);
	// show location modal
	useEffect(() => {
		if (
			searchData.locationModalToggle &&
			searchData.location.blocked &&
			searchData.locationChecked
		) {
			setModalStateLocation(true);
		}
	}, [
		searchData.locationModalToggle,
		searchData.locationChecked,
		searchData.location.blocked,
	]);

	// modals states
	const modalState = () => {
		setModalState(false);
	};
	const modalSearchState = () => {
		setsearchModalState(false);
	};
	const modalLocationState = () => {
		setModalStateLocation(false);
		dispatch(toggleLocationModal(false));
	};
	const clearMobileInputValue = async () => {
		await dispatch(setCityData({ name: "", value: "" }));
		await dispatch(setActivityFacilityData({ name: "", value: "" }));
		setHasFilters(false);
		if (props.hasMap) {
			dispatch(setLoading(true));
		}
	};
	const fetchData = () => {
		if (props.hasMap) {
			dispatch(setLoading(true));
		}
	};
	return (
		<div className="search-inner">
			<div className="wrapper">
				<div className="search__cont-mobile">
					<div className="search__control">
						<LocationBtn
							searchData={searchData}
							url={global.url}
						/>
						<div className="search__fields-block">
							<div
								className="search__fields"
								onClick={() => setsearchModalState(true)}>
								{localization.mobileSearchPlaceholder}
							</div>
							<ClearFieldsMobileCont
								searchData={searchData}
								hasFilters={hasFilters}
								callback={setsearchModalState}>
								<ClearFieldsBtn callback={clearMobileInputValue} />
							</ClearFieldsMobileCont>
						</div>
					</div>
					<ToggleFiltersMobileBtn
						label={localization.searchBtn}
						callback={setModalState}
					/>
				</div>
				<form
					ref={formRef}
					className="search__cont-desktop">
					<div className="search__fields">
						<div className="search__field search__field--nested">
							<LocationBtn
								searchData={searchData}
								url={global.url}
							/>
							<AjaxSelect
								id={"city"}
								placeholder={global.localization.searchCityPlaceholder}
								defaultInputValue={
									searchData.city.value !== "" ? searchData.city.value : ""
								}
								name={searchData.city.name !== "" ? searchData.city.name : ""}
								inverted={false}
								localization={localization}
								resultsType="city"
							/>
						</div>
						<div className="search__field">
							<AjaxSelect
								id={"facility-activity"}
								placeholder={
									global.localization.searchActivityFacilityPlaceholder
								}
								defaultInputValue={
									searchData.activityFacility.value !== ""
										? searchData.activityFacility.value
										: ""
								}
								name={
									searchData.activityFacility.name !== ""
										? searchData.activityFacility.name
										: ""
								}
								inverted={false}
								localization={localization}
								resultsType="activityFacility"
							/>
						</div>
						<SearchBtn
							callback={fetchData}
							label={localization.searchBtn}
						/>
					</div>
					<ToggleFiltersDesktopBtn
						label={localization.filters}
						filters={searchData.filters}
						callback={setModalState}
					/>
				</form>
			</div>
			<FiltersModal
				toggleModal={modalIsOpen}
				callback={modalState}></FiltersModal>
			<SearchModal
				toggleModal={searchModalIsOpen}
				callback={modalSearchState}
				startSearch={fetchData}
				hasFilters={hasFilters}></SearchModal>
			<LocationModal
				toggleModal={modalStateLocation}
				callback={modalLocationState}
			/>
		</div>
	);
};

export default Search;
